export default __webpack_public_path__ + "static/media/ripple-loader.336fd2bf.gif";